import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router'

/**
 * The Studio's Templates tab moved to the Bundles page (2 Nov 2026): saved
 * scene sets, layout packs and files to My library, widgets and transitions to
 * Pieces. Old links to it land on My library.
 */
export function studioTemplatesRedirect(to: Pick<RouteLocationNormalized, 'query'>): RouteLocationRaw | true {
  return to.query.tab === 'templates' ? { path: '/bundles', query: { tab: 'library' } } : true
}
